import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewBalanzaMixer = () => import('./Index')
const ViewOTPendientes = () => import('./OTPendientes/index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'adm_balanza_cf',
        name: 'Balanza Mixer',
        component: ViewBalanzaMixer,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'ot_pendientes',
        name: 'OT Pendientes',
        component: ViewOTPendientes,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
